import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1.0,
  },
  contentContainer: {
    paddingHorizontal: 18,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
  titleText: {
    justifyContent: 'center',
    alignSelf: 'auto',
    alignItems: 'center',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'karla-bold',
    fontSize: 24,
    marginTop: 23,
    width: '105%',
  },
  subQuestionTitle: {
    textAlign: 'center',
    marginBottom: 20,
    fontFamily: 'karla-bold',
    fontSize: 24,
  },
  toolTipImage: { width: 20, height: 20 },
  toolTipButton: { alignSelf: 'center' },
  buttonToggleCustomStyle: { marginBottom: 40 },
  autocompleteInput: {
    borderRadius: 20,
  },
  chipContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 15,
    flexWrap: 'wrap',
    minHeight: 50,
  },
  chipWrapContainer: {
    margin: 5,
  },
  chipText: {
    paddingLeft: 10,
    color: 'white',
    fontSize: 12,
    fontWeight: '500',
  },
  autocompleteInputContainer: {
    borderRadius: 40,
    paddingTop: 5,
    paddingLeft: 20,
    paddingRight: 20,
    height: 60,
    borderWidth: 0,
    marginBottom: 5,
    marginHorizontal: 18,
  },
  textInputContainerCentered: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  autocompleteTextInput: {
    height: 50,
    paddingLeft: 5,
    fontSize: 16,
    fontWeight: '500',
    width: '80%',
    paddingHorizontal: 18,
  },
  autocompleteList: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    display: 'flex',
    position: 'relative',
  },
  autocompleteListButtons: {
    borderRadius: 40,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 20,
    height: 50,
    width: '85%',
    borderWidth: 1,
    marginBottom: 5,
    alignSelf: 'center',
  },
  autocompleteListButtonText: {
    height: 50,
    fontSize: 16,
    paddingTop: 5,
    fontWeight: '500',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default styles
